const toggleDropdown = (e) => {
  const dropdown = e.target.closest('.dropdown')
  if (!dropdown) return

  const menu = dropdown.querySelector('.dropdown-menu')
  const toggle = dropdown.querySelector('[data-toggle="dropdown"]')

  setTimeout(
    () => {
      const shouldOpen = e.type !== 'click' && dropdown.matches(':hover')
      dropdown.classList.toggle('show', shouldOpen)
      menu.classList.toggle('show', shouldOpen)
      if (toggle) toggle.setAttribute('aria-expanded', shouldOpen)
    },
    e.type === 'mouseleave' ? 10 : 0
  )
}

const handleDropdownClick = (e) => {
  const toggle = e.currentTarget
  const parent = toggle.closest('.dropdown')
  if (!parent) return

  if (parent.classList.contains('show')) {
    window.location.href = toggle.getAttribute('href')
  } else {
    e.preventDefault()
    parent.classList.add('show')
    toggle.setAttribute('aria-expanded', 'true')
  }
}

export const initMenu = () => {
  document.querySelectorAll('.dropdown-menu .dropdown-toggle').forEach(function (element) {
    element.addEventListener('click', function (event) {
      event.stopPropagation()
    })
  })

  if (window.matchMedia('(min-width:1200px)').matches) {
    document.querySelectorAll('.main-menu .dropdown-toggle').forEach((toggle) => {
      toggle.addEventListener('click', handleDropdownClick)
    })
    document.querySelectorAll('.main-menu .dropdown').forEach((dropdown) => {
      dropdown.addEventListener('mouseenter', toggleDropdown)
      dropdown.addEventListener('mouseleave', toggleDropdown)
    })
    document.querySelectorAll('.main-menu .dropdown-submenu').forEach((submenu) => {
      const menu = submenu.querySelector('.dropdown-menu')

      submenu.addEventListener('mouseenter', () => {
        submenu.classList.add('show')
        if (menu) menu.classList.add('show')
      })

      submenu.addEventListener('mouseleave', () => {
        submenu.classList.remove('show')
        if (menu) menu.classList.remove('show')
      })
    })
  }

  if (window.matchMedia('(max-width:1199px)').matches) {
    const menuActive = document.querySelector('#offcanvasMenu .offcanvas-body .main-menu > li.active')

    if (menuActive) {
      for (const child of menuActive.children) {
        if (child.tagName === 'A' || child.tagName === 'UL') {
          child.classList.add('show')
        }
      }
    }
  }
}
